module.exports = __webpack_public_path__ + "img/index-vree-logo.e9b38641.png";